// 実装ガイド: https://docs.virtusize.com/ja/integration/general/productDetail.html
import { VsOrderObject } from "~/types/virtusize"

const VS_STORE_NAME = "tential"
const VS_ENV = "production" // "staging" or "production"
const VS_DEVICE_TYPE = "desktop"
const VS_DOMAIN = "jp" // "staging" では "com", "production" では国別コードを設定（日本＝"jp"、韓国＝"kr"、中国＝"com.cn"、それ以外="com"）
const VIRTUSIZE_SCRIPT_NAME = "virtusize-script" as const
const VIRTUSIZE_CONFIRMATION_SCRIPT_NAME = "virtusize-order-confirmation" as const

export const appendVirtusizeScriptTag = () => {
  const src = `${document.location.protocol}//integration.virtusize.jp/${VS_ENV}/${VS_STORE_NAME}/${VS_DEVICE_TYPE}.source.js`
  loadScript(src, VIRTUSIZE_SCRIPT_NAME, "text/javascript", true)
}

export const appendVirtusizeOrderConfirmationTag = (apiKey: string, orderObject: VsOrderObject) => {
  window.vsEnv = VS_ENV
  window.vsDomain = VS_DOMAIN
  window.vsApiKey = apiKey
  window.vsOrderObject = orderObject
  const scriptUrl = `https://integration.virtusize.com/orders/confirmation.js`
  loadScript(scriptUrl, VIRTUSIZE_CONFIRMATION_SCRIPT_NAME, "text/javascript", true)
}

export const removeVirtusizeScriptTag = (
  scriptName: typeof VIRTUSIZE_SCRIPT_NAME | typeof VIRTUSIZE_CONFIRMATION_SCRIPT_NAME,
) => {
  removeScript(scriptName)
}
